import { inject } from '@angular/core';
import { Router, CanActivateFn, ActivatedRouteSnapshot } from '@angular/router';
import { firstValueFrom } from 'rxjs';
import { ProjectService } from '../services/project.service';
import { SupabaseService } from '../../../core/supabase.service';
import { canManageProject } from '../models/project-role';

export const canEditProjectGuard: CanActivateFn = async (route: ActivatedRouteSnapshot) => {
  const router = inject(Router);
  const projectService = inject(ProjectService);
  const supabase = inject(SupabaseService);

  const idParam = route.paramMap.get('id');

  if (!idParam) {
    router.navigate(['/project-management']);
    return false;
  }

  try {
    // Get current user
    const userResponse = await supabase.client.auth.getUser();
    const currentUserId = userResponse.data.user?.id;

    if (!currentUserId) {
      router.navigate(['/project-management/access-denied']);
      return false;
    }

    // Resolve identifier to UUID if needed
    const isUuid = /^[0-9a-f]{8}-[0-9a-f]{4}-/i.test(idParam);
    let projectId = idParam;

    if (!isUuid) {
      const resolved = await firstValueFrom(projectService.getProjectByIdentifier(idParam));
      if (!resolved?.id) {
        router.navigate(['/project-management']);
        return false;
      }
      projectId = resolved.id;
    }

    // Le role effectif suffit : getCurrentUserRole() traite deja le cas du
    // manager du projet (projects.manager_id), inutile de le tester a part.
    //
    // CE QUE CE GUARD LISAIT AVANT, ET POURQUOI IL BLOQUAIT
    // Il cherchait `currentMember.role.permissions`. Depuis la bascule vers les
    // roles fixes, `role` est une CHAINE ('manager'), pas un objet : la liste
    // etait donc systematiquement vide, et toute personne manager par son
    // appartenance — sans etre projects.manager_id — se voyait renvoyer vers
    // access-denied. Constate en production sur un compte pourtant manager.
    const role = await firstValueFrom(projectService.getCurrentUserRole(projectId));

    if (canManageProject(role)) {
      return true;
    }

    router.navigate(['/project-management/access-denied']);
    return false;
    
  } catch (error) {
    console.error('Error checking project edit permissions:', error);
    router.navigate(['/project-management/access-denied']);
    return false;
  }
};